import { Concept } from 'modules/Documents/models/document';
import { VerifactuLine } from 'modules/Documents/models/verifactuDocument';
import {
  NonTaxableTaxType,
  TaxOption,
  TaxType,
  formatNonTaxableTaxKey,
  formatTaxKey,
  isValidTaxType,
} from 'modules/Taxes';

export const normalizeVerifactuLineToConcept = (
  line: VerifactuLine
): Concept => {
  const taxType = isValidTaxType(line.taxes?.taxType)
    ? line.taxes.taxType
    : TaxType.IVA;
  const taxKey = line.taxes?.nonTaxableTaxType
    ? formatNonTaxableTaxKey(
        taxType,
        line.taxes.nonTaxableTaxType as NonTaxableTaxType,
        0
      )
    : formatTaxKey(taxType, line.taxes?.taxRate || 0);

  formatTaxKey(taxType, line.taxes?.taxRate || 0);

  const tax: TaxOption | undefined = line.taxes
    ? {
        label: `${line.taxes.taxRate}% ${taxType}`,
        amount: line.taxes.taxRate,
        type: taxType,
        value: taxKey,
        salesEqTaxPercentage: line.taxes.equivalenceSurchargeRate,
      }
    : undefined;

  return {
    name: line.title,
    description: line.description,
    quantity: line.quantity,
    unitPrice: line.unitPrice,
    discountPercentage: line.discountRate,
    totalAmount: line.totalAmount,
    totalWithoutTaxes: line.taxes?.taxBase,
    tax,
    taxKey,
    product: line.product?.id,
    productReference: line.productReference,
  };
};
